export const SET_USER_PROFILE_REQUEST = 'SET_USER_PROFILE_REQUEST';
export const SET_USER_PROFILE_SUCCESS = 'SET_USER_PROFILE_SUCCESS';
export const SET_USER_PROFILE_FAILED = 'SET_USER_PROFILE_FAILED';
export const SET_EMAIL = 'SET_EMAIL';
export const SET_ROLE = 'SET_ROLE';
export const CLEAN_USER = 'CLEAN_USER';
